import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { getSideSection, getValueOption, valueOption } from '../../store/selectors/selectors'
import { dependencySettingT, IComponent } from '../../utils/type/dynamic-rendering.interfaces'
import { DistributeComponents } from '../DistributeComponents/DistributeComponents'
 //@ts-ignore
import s from './OptionsSide.module.scss'

type optionsSideT = {
    embeddedView: any[],
    children: any,
    id: string,
    typeOptions: string,
    dependencySettings?: dependencySettingT[]
   
}

export const OptionsSide: FC<optionsSideT> = ({ ...pros }) => {
    let { children, id } = pros;

    let { selectValue }: valueOption = useSelector(state => getValueOption({idOptions:'orientationSide'})(state));
    let tempSectionSide: IComponent[] = useSelector(getSideSection);
    let groupsSide = id.split('OptionsSideGroup_')[1];

    return (
        <>
            {
                !!selectValue && groupsSide === selectValue && <div>
                    <div className={s.main}>
                        {
                            tempSectionSide && tempSectionSide.length > 0 && tempSectionSide.map((setting: IComponent, index: any) => {
                                let keySection = setting['data']['keySection']
                                return (<DistributeComponents parentKeySection={keySection} key={`${setting['data']['id']}+${index}`} {...setting} />)
                            })
                        }
                        {children}
                    </div>
                </div>
            }
        </>
    )
}
